import { InfoOutlined } from "@mui/icons-material";
import {
  ListItemText,
  MenuItem,
  Typography,
  Select,
  Box,
  FormHelperText,
  Stack,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { Controller } from "react-hook-form";

export default function FormDropDown({
  dropdownValues,
  fieldname,
  control,
  label,
  required,
  rules,
  defaultValue,
  infoText,
}) {
  const [currentKey, setCurrentKey] = useState("");
  const [currentMatchIndex, setCurrentMatchIndex] = useState(0);
  // Merge required rule if `required` prop is true
  const combinedRules = required
    ? { ...rules, required: `This field is required` }
    : rules;
  const handleKeyDown = (event, onChange) => {
    const pressedKey = event?.key?.toLowerCase();

    // Filter options starting with the pressed key
    const matchingOptions = dropdownValues?.filter((item) =>
      item?.label?.toLowerCase()?.startsWith(pressedKey)
    );

    if (matchingOptions?.length > 0) {
      if (pressedKey !== currentKey) {
        // Reset index when a new key is pressed
        setCurrentKey(pressedKey);
        setCurrentMatchIndex(0);
        onChange(matchingOptions[0]?.value); // Select the first match
      } else {
        // Cycle through matches for the same key
        const nextIndex = (currentMatchIndex + 1) % matchingOptions?.length;
        setCurrentMatchIndex(nextIndex);
        onChange(matchingOptions[nextIndex]?.value);
      }
    }
  };

  return (
    <Controller
      defaultValue={defaultValue || ""}
      name={fieldname}
      control={control}
      rules={combinedRules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box onKeyDown={(event) => handleKeyDown(event, onChange)}>
          {/* <Typography variant="body1" textAlign={"left"}>
            {label} {required && <span style={{ color: "red" }}>*</span>}
          </Typography> */}
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="body1" textAlign={"left"}>
              {label} {required && <span style={{ color: "red" }}>*</span>}
            </Typography>
            {infoText && (
              <Tooltip title={infoText} placement="right">
                <IconButton size="small">
                  <InfoOutlined fontSize="small" color="action" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>

          <Select
            fullWidth
            size="small"
            value={value || ""}
            onChange={onChange}
            displayEmpty
            // native
            error={!!error}
            sx={{
              padding: "0px", // Remove extra padding
              textAlign: "left", // Ensure text is aligned to the left
            }}
            renderValue={(selected) => {
              // If no value is selected, show the placeholder
              if (!selected) {
                return (
                  <Typography sx={{ color: "gray" }}>
                    Select an option
                  </Typography>
                );
              }
              const selectedItem = dropdownValues.find(
                (item) => item.value === selected
              );
              return selectedItem ? selectedItem.label : selected;
            }}
          >
            {/* Dropdown values */}
            {dropdownValues?.map((val, i) => (
              <MenuItem key={i} value={val?.value}>
                <ListItemText primary={val?.label} />
              </MenuItem>
            ))}
          </Select>
          {/* Display error message if there's an error */}
          {error && <FormHelperText error>{error?.message}</FormHelperText>}
        </Box>
      )}
    />
  );
}
